interface ScriptBlockSource<T> {
  tryParseHTMLToBlocks(html: string): T[];
  tryParseMarkdownToBlocks(markdown: string): T[] | Promise<T[]>;
}

interface ScriptHtmlEditor<T> {
  document: T[];
  blocksToHTMLLossy(blocks?: T[]): string;
}

function asDocumentHtml(source: string) {
  return source
    .replace(/<pre\b[^>]*>\s*<code\b[^>]*>/gi, "<p>")
    .replace(/<\/code>\s*<\/pre>/gi, "</p>");
}

export function isSchemaScriptHtml(value: string) {
  const trimmed = value.trim();
  if (!trimmed.startsWith("<") || /<pre\b/i.test(trimmed)) return false;
  return /<(p|h1|h2|h3|ul|ol|blockquote)\b/i.test(trimmed);
}

export async function blocksFromScript<T>(editor: ScriptBlockSource<T>, source: string): Promise<T[]> {
  const value = source.trim();
  if (value.startsWith("<")) {
    try {
      const htmlBlocks = editor.tryParseHTMLToBlocks(asDocumentHtml(value));
      if (htmlBlocks.length) return htmlBlocks;
    } catch {
      // The saved string looks like markup but is not editor HTML.
    }
  }
  try {
    return await editor.tryParseMarkdownToBlocks(value || " ");
  } catch {
    return await editor.tryParseMarkdownToBlocks(" ");
  }
}

export function documentToScriptHtml<T>(editor: ScriptHtmlEditor<T>): string {
  try {
    return editor.blocksToHTMLLossy(editor.document);
  } catch {
    return "";
  }
}
